import {
  getTermsClient,
  makeOptionallyAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import {
  buildAxiosRequestConfig,
  decodeAccessToken,
} from '@b-stock/fe-core/bstock-react'

/**
 * Fetches the accepted policies for the current user.
 *
 * @param accessToken - The user's access token
 * @returns The user's accepted policies as a Record<string, unknown>
 */
const getAcceptedPolicies = async (
  accessToken: string | null
): Promise<Record<string, unknown>> => {
  if (!accessToken) {
    return {}
  }

  try {
    const decodedToken = decodeAccessToken(accessToken)
    const { accountId } = decodedToken

    if (!accountId) {
      return {}
    }

    const termsClient = getTermsClient()
    const reqOpts = buildAxiosRequestConfig({ accessToken })

    const response = await termsClient.getAcceptedPolicies(
      { id: accountId },
      reqOpts
    )

    return response.data
  } catch (error) {
    console.error('Failed to fetch accepted policies:', error)
    return {}
  }
}

/**
 * Query for fetching the current user's accepted policies.
 * Returns an empty object if user is not authenticated or if fetch fails.
 *
 * @category Queries
 */
const acceptedPoliciesQuery = makeOptionallyAuthenticatedQuery(
  'acceptedPolicies',
  getAcceptedPolicies
)

export default acceptedPoliciesQuery
